/* ─── A1CW Theme V2 · theme.js ─────────────────────────
   Site-wide JS: mobile nav, search guard, quote modal,
   newsletter feedback. Vanilla ES2020+, no dependencies.
   ──────────────────────────────────────────────────── */

(function () {
  'use strict';

  // ── Mobile nav toggle ───────────────────────────────
  const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav    = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // ── Header search guard ─────────────────────────────
  document.querySelectorAll('[data-header-search]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const input = form.querySelector('input[name="q"]');
      if (input && !input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  });

  // ── Quote modal open/close (delegated) ──────────────
  function openQuoteModal(productHandle, variantId, productTitle) {
    const modal = document.querySelector('[data-quote-modal]');
    if (!modal) return;
    const handleField  = modal.querySelector('input[name="contact[product]"]');
    const variantField = modal.querySelector('input[name="contact[variant_id]"]');
    const titleField   = modal.querySelector('input[name="contact[product_title]"]');
    if (handleField)  handleField.value  = productHandle || '';
    if (variantField) variantField.value = variantId || '';
    if (titleField)   titleField.value   = productTitle || '';
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-open-quote-modal]');
    if (trigger) {
      e.preventDefault();
      openQuoteModal(
        trigger.dataset.productHandle,
        trigger.dataset.variantId,
        trigger.dataset.productTitle
      );
    }
    const closer = e.target.closest('[data-close-quote-modal]');
    if (closer) {
      const modal = closer.closest('dialog');
      if (modal) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
    }
  });

  // ── Newsletter inline feedback ──────────────────────
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
    });
  });

  // ── Lazy fetch related products (if a section asks) ─
  document.querySelectorAll('[data-related-products]').forEach(function (el) {
    const productId = el.dataset.productId;
    const sectionId = el.dataset.sectionId;
    if (!productId || !sectionId) return;
    const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=4`;
    fetch(url)
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const fresh = tmp.querySelector('[data-related-products]');
        if (fresh) el.replaceWith(fresh);
      })
      .catch(() => { /* silently leave the placeholder */ });
  });
})();
